import { useState } from 'react';

// 18+ age confirmation component for signup flow.
// onConfirm is called when the user clicks through — the parent is responsible for
// logging to the age_verifications table via Supabase after account creation.
export default function AgeGate({ onConfirm, style = {} }) {
  const [checked, setChecked] = useState(false);
  const [aiChecked, setAiChecked] = useState(false);
  const [attempted, setAttempted] = useState(false);

  function handleContinue() {
    setAttempted(true);
    if (checked && aiChecked) {
      onConfirm?.();
    }
  }

  const missingAge = attempted && !checked;
  const missingAI = attempted && !aiChecked;

  const checkboxStyle = (error) => ({
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    padding: '14px 16px',
    background: error ? 'rgba(198,40,40,0.08)' : 'rgba(196,168,130,0.05)',
    border: `1px solid ${error ? 'rgba(198,40,40,0.35)' : 'rgba(196,168,130,0.15)'}`,
    borderRadius: '10px',
    marginBottom: '10px',
    cursor: 'pointer',
    transition: 'border-color 0.2s',
  });

  return (
    <div style={{ ...style }}>
      <div style={{
        fontFamily: "'Cinzel', serif",
        fontSize: '12px',
        letterSpacing: '2px',
        color: '#8a7a65',
        textTransform: 'uppercase',
        marginBottom: '16px',
      }}>
        Before You Continue
      </div>

      <label style={checkboxStyle(missingAge)} onClick={() => setChecked(v => !v)}>
        <div style={{
          width: '20px',
          height: '20px',
          flexShrink: 0,
          marginTop: '1px',
          border: `2px solid ${checked ? '#c4a882' : missingAge ? 'rgba(198,40,40,0.6)' : 'rgba(196,168,130,0.35)'}`,
          borderRadius: '4px',
          background: checked ? 'rgba(196,168,130,0.2)' : 'transparent',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'all 0.15s',
        }}>
          {checked && <span style={{ color: '#c4a882', fontSize: '13px', lineHeight: 1 }}>✓</span>}
        </div>
        <span style={{
          color: '#c4b99a',
          fontSize: '14px',
          lineHeight: '1.6',
          fontFamily: "'Cormorant Garamond', Georgia, serif",
          userSelect: 'none',
        }}>
          I confirm that I am <strong style={{ color: '#f0e6d0' }}>18 years of age or older</strong>. I understand that My Fate, My Love is an adult platform and that creating an account while under 18 is prohibited.
        </span>
      </label>

      <label style={checkboxStyle(missingAI)} onClick={() => setAiChecked(v => !v)}>
        <div style={{
          width: '20px',
          height: '20px',
          flexShrink: 0,
          marginTop: '1px',
          border: `2px solid ${aiChecked ? '#c4a882' : missingAI ? 'rgba(198,40,40,0.6)' : 'rgba(196,168,130,0.35)'}`,
          borderRadius: '4px',
          background: aiChecked ? 'rgba(196,168,130,0.2)' : 'transparent',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'all 0.15s',
        }}>
          {aiChecked && <span style={{ color: '#c4a882', fontSize: '13px', lineHeight: 1 }}>✓</span>}
        </div>
        <span style={{
          color: '#c4b99a',
          fontSize: '14px',
          lineHeight: '1.6',
          fontFamily: "'Cormorant Garamond', Georgia, serif",
          userSelect: 'none',
        }}>
          I understand that <strong style={{ color: '#f0e6d0' }}>all characters are AI-generated</strong> — not real people — and that MFML is an entertainment platform, not a mental health service or real relationship.
        </span>
      </label>

      {attempted && (!checked || !aiChecked) && (
        <p style={{
          color: 'rgba(198,100,100,0.9)',
          fontSize: '13px',
          margin: '4px 0 12px',
          fontFamily: "'Cormorant Garamond', Georgia, serif",
        }}>
          Please confirm both items above to continue.
        </p>
      )}

      <p style={{
        fontSize: '12px',
        color: '#4a4030',
        margin: '12px 0 16px',
        lineHeight: '1.6',
        fontFamily: "'Cormorant Garamond', Georgia, serif",
      }}>
        By creating an account you agree to our{' '}
        <a href="/terms" style={{ color: '#6a5f4f', textDecoration: 'underline' }}>Terms of Service</a>
        {' '}and{' '}
        <a href="/privacy" style={{ color: '#6a5f4f', textDecoration: 'underline' }}>Privacy Policy</a>.
      </p>

      <button
        onClick={handleContinue}
        style={{
          width: '100%',
          padding: '13px',
          background: checked && aiChecked
            ? 'linear-gradient(135deg, rgba(196,168,130,0.2) 0%, rgba(196,168,130,0.1) 100%)'
            : 'rgba(196,168,130,0.06)',
          border: `1px solid ${checked && aiChecked ? 'rgba(196,168,130,0.4)' : 'rgba(196,168,130,0.15)'}`,
          borderRadius: '10px',
          color: checked && aiChecked ? '#c4a882' : '#4a4030',
          fontFamily: "'Cinzel', serif",
          fontSize: '13px',
          letterSpacing: '2px',
          cursor: 'pointer',
          transition: 'all 0.2s',
        }}
      >
        Create Account
      </button>
    </div>
  );
}
